__turbopack_context__.v({
  "documentsTable__columnActions": "DocumentsTable-module__Dgpdjq__documentsTable__columnActions",
  "documentsTable__columnCreatedAt": "DocumentsTable-module__Dgpdjq__documentsTable__columnCreatedAt",
  "documentsTable__columnDescription": "DocumentsTable-module__Dgpdjq__documentsTable__columnDescription",
  "documentsTable__columnName": "DocumentsTable-module__Dgpdjq__documentsTable__columnName",
  "documentsTable__columnSize": "DocumentsTable-module__Dgpdjq__documentsTable__columnSize",
  "documentsTable__columnTags": "DocumentsTable-module__Dgpdjq__documentsTable__columnTags",
  "documentsTable__columnUpdatedAt": "DocumentsTable-module__Dgpdjq__documentsTable__columnUpdatedAt",
});
